import { Outlet, Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../Contexts/AuthContext';

export default function ProtectedRoute() {
    const location = useLocation();
    const { user } = useAuth();
    return user ? <Outlet /> : <Navigate to="/connexion" state={{redirectPath: location.pathname, mustConnect: true}} />;
} 
